import { queryClient } from '@configuration/queryClient.config';
import { useSuspenseQuery } from '@tanstack/react-query';
import { loadAnnouncementItemsAPI } from '@/service';

const loadAnnouncementItemsBaseQueryKey = 'loadAnnouncementItems';
export const loadAnnouncementItemsQueryKey = (id: number) => [
  loadAnnouncementItemsBaseQueryKey,
  id,
];

export const useLoadAnnouncementItemsQuery = (id: number) => {
  return useSuspenseQuery({
    queryKey: loadAnnouncementItemsQueryKey(id),
    queryFn: () => loadAnnouncementItemsAPI({ id, blackAndWhite: false }),
  });
};

export const invalidateLoadAnnouncementItemsQuery = () =>
  queryClient.invalidateQueries({
    queryKey: [loadAnnouncementItemsBaseQueryKey],
  });
